import $ from 'jquery';
//import { spring } from "motion"
import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/effect-fade';

import SimpleLightbox from "simplelightbox/dist/simple-lightbox.esm"; // <- ESM Build (Vite-friendly)
import "simplelightbox/dist/simple-lightbox.min.css"; // <- CSS rein



window.$ = $;
window.Swiper = Swiper;

const lightbox = new SimpleLightbox(".zoom", {
    closeText: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M19.0605 2.00977L11.5391 9.5293L19.0605 17.0508L17.0508 19.0605L9.5293 11.5391L2.00879 19.0605L0 17.0508L7.52051 9.53027L0 2.00977L2.00977 0L9.53027 7.52051L17.0508 0L19.0605 2.00977Z" fill="#ffffff"/>\n' +
        '</svg>\n',
    navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80"><path fill="#ffffff" fill-rule="evenodd" d="M36.089 40 50.5 54.658 47.705 57.5 30.5 40l17.205-17.5 2.795 2.842z"/></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80"><path fill="#ffffff" fill-rule="evenodd" d="M44.911 40 30.5 54.658l2.795 2.842L50.5 40 33.295 22.5 30.5 25.342z"/></svg>'
    ],
    captions: false,
    showCounter: false,
    history: false,
    overlayOpacity: 0.8

});

/*const swiper = new Swiper('.swiper', {
    slidesPerView: 1,
    effect: 'fade',
    loop: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: true,
    },
    pagination: {
        el: '.hero-swiper .swiper-pagination',
        type: 'bullets',
        clickable: true,
    }
});*/

/*// Füge stattdessen hinzu:
if (typeof window.global === 'undefined') {
    window.global = window;
}

// Dann dynamisch laden:
(async () => {
    try {
        const mod = await import('simplelightbox/dist/simple-lightbox.esm.js');
        const SimpleLightbox = mod.default || mod;
        new SimpleLightbox('.zoom', { /!* options *!/ });
    } catch (e) {
        console.error('SimpleLightbox konnte nicht geladen werden:', e);
    }
})();*/

$('[data-modal]').click(function (e) {
    e.preventDefault();

    // create dialog if not exists
    if ($('dialog').length === 0) {
        $('body').append('<dialog></dialog>');
    }

    const dialog = document.querySelector('dialog');
    $(dialog).prop('id', 'modal-' + $(this).data('modal'));
    $.ajax({
        url: $(this).data('action'),
        method: 'GET',
        success: function (data) {
            $('dialog').html(data).focus();
            dialog.showModal();

            // Click outside to close
            function onClick(event) {
                if (event.target === dialog) {
                    dialog.close();
                    $('dialog').remove();
                }
            }
            dialog.addEventListener("click", onClick);

            const closeButton = document.querySelector("dialog button");
            closeButton.addEventListener("click", () => {
                dialog.close();
                $('dialog').remove();
                dialog.removeEventListener("click", onClick); // Cleanup
            });
        }
    });
});

// faq
const accordionButtons = $(".faq-button");
accordionButtons.on("click", function () {
    const $button = $(this);
    const isExpanded = $button.attr("aria-expanded") === "true";
    const $content = $button.closest('.faq-item').find('.faq-content');

    // Nur das aktuelle Element toggle
    if (isExpanded) {
        $button.attr("aria-expanded", "false");
        $content.css('max-height', '0');
        setTimeout(() => {
            if ($content.css('max-height') === '0px') {
                $content.attr("hidden", "");
            }
        }, 300);
    } else {
        $button.attr("aria-expanded", "true");
        $content.removeAttr("hidden").css('max-height', $content[0].scrollHeight + 'px');
    }
});


$('.close').click(function() {
    $(this).closest('.modal').fadeOut();
    $('#search').fadeOut();
    $('body').css('overflow', '').removeClass('active');
});

$(document).on('click', 'nav.main.mobile > ul > li > a', function(e) {
    const $li = $(this).parent('li');

    // Nur verhindern, wenn das li ein Submenu hat
    if ($li.children('ul').length > 0) {
        e.preventDefault();

        if ($li.hasClass('open')) {
            $li.removeClass('open');
        } else {
            $('nav.main.mobile ul li').removeClass('open');
            $li.addClass('open');
        }
    }
});

// Button-Handler ohne verschachteltes Binding
$('.nav-mobile button').click(function() {
    $(this).toggleClass('active');
    $('.nav-container').toggleClass('open');
    $('.nav-container nav').toggleClass('mobile');

    // Alle schließen beim Öffnen des Menüs
    $('nav.main.mobile ul li').removeClass('open');

    // Scrollen deaktivieren, wenn Menü offen ist
    if ($('.nav-container').hasClass('open')) {
        $('body').css('overflow', 'hidden');
    } else {
        $('body').css('overflow', '');
    }
});

$('.scroll-down').click(function() {
    const $section = $(this).parents('section').first();
    const $el = $section.next();
    if ($el.length === 0) return;
    const headerHeight = $('header.main').outerHeight() || 0;
    const target = $el.offset().top - headerHeight;
    window.scrollTo({ top: target, behavior: 'smooth' });
});


// hide .call-to-action on scroll down 20% of page height, blend black in on scroll up (even if not at top)
let lastScrollTop = 0;
let isCallToActionVisible = true;

$(window).on('scroll', function() {
    const scrollTop = $(this).scrollTop();
    const docHeight = $(document).height();
    const winHeight = $(this).height();
    const scrollPercent = scrollTop / (docHeight - winHeight);
    const isScrollingDown = scrollTop > lastScrollTop;

    if (scrollPercent > 0.1) {
        if (isScrollingDown && isCallToActionVisible) {
            $('.call-to-action').fadeOut();
            isCallToActionVisible = false;
        } else if (!isScrollingDown && !isCallToActionVisible) {
            $('.call-to-action').fadeIn();
            isCallToActionVisible = true;
        }
    } else {
        // Immer einblenden bei < 10%
        if (!isCallToActionVisible) {
            $('.call-to-action').fadeIn();
            isCallToActionVisible = true;
        }
    }

    lastScrollTop = scrollTop;
});



$('.clickable').click(function(e){
    let $this = $(this);

    // Check if click was on the actual clickable element or its children
    let $target = $(e.target).closest('.clickable');
    if ($target.length && $target.find("a").length) {
        let $link = $target.find("a:first");
        if ($link.attr("target") === "_blank") {
            window.open($link.attr("href"), "_blank");
        } else {
            window.location.href = $link.attr("href");
        }
    }
});

$(document).on('mouseenter', '.group-unilabs-radiology nav.main:not(.mobile)', function() {
    $('body').addClass('active');
});
$(document).on('mouseleave', '.group-unilabs-radiology nav.main:not(.mobile)', function() {
    $('body').removeClass('active');
});

function updateHeaderHeight() {
    const headerHeight = $('header').outerHeight();
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
}

// Initiales Setzen
$(document).ready(updateHeaderHeight);

// Bei Resize mit Throttle
let resizeTimeout;
$(window).on('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateHeaderHeight, 100);
});






document.querySelectorAll('[data-animate]').forEach(element => {
    const threshold = parseFloat(element.dataset.animateThreshold) || 0.5;
    const rootMargin = element.dataset.animateRootMargin || "0px";
    const delay = parseInt(element.dataset.animateDelay) || 0;
    const once = element.dataset.animateOnce !== 'false'; // Default true

    let timeoutId = null;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const el = entry.target;

            if (entry.isIntersecting) {
                // Sofort setzen
                el.classList.add('viewport-start');
                el.classList.remove('viewport-out');

                // Direkt in-view setzen basierend auf threshold
                if (entry.intersectionRatio >= threshold) {
                    el.classList.add('in-view');

                    // Nur bei once=true den Observer stoppen, NACHDEM in-view gesetzt wurde
                    if (once) {
                        observer.unobserve(el);
                    }
                }

                // Mit Delay nur für viewport-full
                if (delay > 0) {
                    timeoutId = setTimeout(() => {
                        if (entry.intersectionRatio >= 0.95) {
                            el.classList.add('viewport-full');
                        }
                    }, delay);
                } else {
                    if (entry.intersectionRatio >= 0.95) {
                        el.classList.add('viewport-full');
                    }
                }

            } else {
                // Pending setTimeout clearen
                if (timeoutId) {
                    clearTimeout(timeoutId);
                    timeoutId = null;
                }

                // Element verlässt Viewport (nur wenn once=false)
                if (!once) {
                    el.classList.add('viewport-out');
                    el.classList.remove('viewport-start', 'viewport-full', 'in-view');
                }
            }
        });
    }, {
        root: null,
        rootMargin: rootMargin,
        threshold: [0, threshold, 0.95]
    });

    observer.observe(element);

    // Mouse Events
    element.addEventListener('mouseenter', () => {
        element.classList.add('mouse-in');
        element.classList.remove('mouse-out');
    });

    element.addEventListener('mouseleave', () => {
        element.classList.add('mouse-out');
        element.classList.remove('mouse-in');
    });
});